<template>
	<!-- 商品 -->
	<div class="commodity-wrapper">
		<!-- 轮播图 -->
		<info-goods-swipe></info-goods-swipe>
		<!-- 商品信息 -->
		<info-item></info-item>
		<!-- 促销信息 -->
		<info-promotions></info-promotions>
		<!-- 促销商品的活动结束时间 -->
		<info-promos-time></info-promos-time>
		<!-- 购买 -->
		<info-buy></info-buy>
		<!-- 联系客服-->
		<!-- <info-contact></info-contact> -->
		<!-- 评论 -->
		<!-- <info-goods-review></info-goods-review> -->
		<!-- 点赞 -->
		<!-- <info-like></info-like> -->

		<!-- 商品搭配 -->
		<!-- <accessory-item></accessory-item> -->
		<!-- 推荐商品  -->
		<recommend-item></recommend-item>
		<div style="height: 0.25rem; background-color: #F0F2F5"></div>
	</div>
</template>

<script>
import InfoGoodsSwipe from './InfoGoodsSwipe'
import InfoItem from './InfoItem'
import InfoPromotions from './InfoPromotions'
import InfoPromosTime from './InfoPromosTime'
import InfoBuy from './InfoBuy'
import InfoContact from './InfoContact'
import InfoLike from './InfoLike'
// import InfoGoodsReview from './InfoGoodsReview'
import RecommendItem from './RecommendItem'
// import AccessoryItem from './AccessoryItem'
import { flowstat_record } from '../../../../api/homestoredetail'

import { mapState, mapMutations } from 'vuex'

export default {
	data() {
		return {}
	},

	created() {},

	components: {
		InfoGoodsSwipe,
		InfoItem,
		InfoPromotions,
		InfoPromosTime,
		InfoBuy,
		InfoContact,
		InfoLike,
		// InfoGoodsReview,
		RecommendItem,
		// AccessoryItem
	},

	computed: mapState({
			storeInfo: state => state.goodsdetail.storeInfo,
			commonInfo: state => state.goodsdetail.commonInfo,
	}),
		created () {
			this.flowstat_record()
		},
	mounted() {},

	methods: {
			flowstat_record () {
				flowstat_record(this.storeInfo.store_id,this.commonInfo.goods_commonid,'Goods').then((res) => {
			 })
		   }
		 }
}

</script>

<style lang="scss" scoped>
.commodity-wrapper {
	height: 100%;
}
</style>
